import { apiRoutes } from '../config-data/apiRoutes';

export const LOAD_ALL_DISCOVER_ELEMENTS = 'LOAD_ALL_DISCOVER_ELEMENTS';
export const LOAD_SINGLE_ARTICLE = 'LOAD_SINGLE_ARTICLE';
export const SELECTED_DISCOVER_ARTICLE = 'SELECTED_DISCOVER_ARTICLE';
export const UNLOAD_SINGLE_ARTICLE = 'UNLOAD_SINGLE_ARTICLE';
export const FILTER_CATEGORY_NAME = 'FILTER_CATEGORY_NAME';

export async function loadAllDiscoverElements() {
	let discoverApiResponse = await fetch(apiRoutes.DISCOVER_ALL);
	let discoverData = await discoverApiResponse.json();

	discoverData = discoverData.map(element => {
		element.visibleByFilter = true;
		return element;
	});
	
	return {
		type: LOAD_ALL_DISCOVER_ELEMENTS,
		payload: {
			discoverData: discoverData
		}
	};
}

// TODO: Write test for this!
export async function loadSingleArticle(slugName) {
	let articleApiResponse = await fetch(apiRoutes.SINGLE_ARTICLE + slugName);
	let articleData = await articleApiResponse.json();

	return {
		type: LOAD_SINGLE_ARTICLE,
		payload: {
			articleData: articleData[0]
		}
	};
}

// TODO: Write test for this.
export async function selectDiscoverArticle(article) {
	return {
		type: SELECTED_DISCOVER_ARTICLE,
		payload: {
			selectedArticle: article
		}
	}
}

export function unloadSingleArticle() {
	return {
		type: UNLOAD_SINGLE_ARTICLE
	}
}


export function toggleCategoryFilterName(filters, filterName, discoverData) {
	const activeFilterValue = true;
	const inactiveFilterValue = false;
	
	let filterIndex = filters.findIndex(f => f.filterId === filterName);

	if (_checkForActiveFilterValue(filters, activeFilterValue)) {
		filters = _setAllFilters(filters, inactiveFilterValue);
	}

	filters[filterIndex].filterIsActive = !filters[filterIndex].filterIsActive;

	if (_checkForActiveFilterValue(filters, inactiveFilterValue)) {
		filters = _setAllFilters(filters, activeFilterValue);
	}

	const filteredItems = _filterDiscoverElements(discoverData, filters);
	return {
		type: FILTER_CATEGORY_NAME,
		payload: {
			updatedFilterItems: filters,
			filteredDiscoverItems: filteredItems
		}
	};
}

function _checkForActiveFilterValue(filters, filterValue) {
	return filters.every(f => f.filterIsActive === filterValue);
	
}

function _setAllFilters(filters, filterValue) {
	return filters.map(f => {
		f.filterIsActive = filterValue;
		return f;
	});
}


function _filterDiscoverElements(discoverElements, filters) {
	const filteredElements = discoverElements.filter(element => {
		const elementCategory = element.acf.category;
		const categoryFilter = filters.find(filter => filter.filterId === elementCategory);

		if (categoryFilter && categoryFilter.filterIsActive) {
			element.visibleByFilter = true;
		} else {
			element.visibleByFilter = false;
		}

		return element;
	});

	return filteredElements;
}



// WEBPACK FOOTER //
// ./src/actions/discover.actions.js